import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import once from '@mailobj-browser/front/js/events/options/once.js'
import passive from '@mailobj-browser/front/js/events/options/passive.js'
import input from '@mailobj-browser/front/js/events/types/input.js'
import load from '@mailobj-browser/front/js/events/types/load.js'
import selectionChange from '@mailobj-browser/front/js/events/types/selectionChange.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import removed from '@mailobj-browser/front/js/tree/removed.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import globals from '../ea/globals.js'
import * as rteUtilities from './styles.js'

const params = new WeakMap()
const tasks = new WeakMap()

const expression = 'descendant-or-self::*/text()'
const modifier = rteUtilities.modifiers.rte.highlight

const selection = (
  document
) => {
  const selection = document.getSelection()
  const { commonAncestorContainer } = selection.getRangeAt(0)
  const { anchorNode, focusNode } = selection
  const nodes = texts(document, commonAncestorContainer)
  const start = nodes.indexOf(anchorNode)
  const end = nodes.indexOf(focusNode)
  const contents = []

  if (selection.containsNode(anchorNode)) {
    contents.push(anchorNode)
  }

  contents.push(...nodes.slice(start, end))

  if (selection.containsNode(focusNode)) {
    contents.push(focusNode)
  }

  return new Set(contents)
}

const texts = (
  document,
  container
) => {
  const { defaultView } = document
  const { XPathResult } = defaultView
  const type = XPathResult.ORDERED_NODE_ITERATOR_TYPE
  const nodes = document.evaluate(expression, container, null, type, null)
  const texts = []

  while (true) {
    const text = nodes.iterateNext()

    if (!text) {
      break
    }

    texts.push(text)
  }

  return texts
}

const onCaretMove = object(listener, {
  passive,
  task: async (
    document
  ) => {
    const texts = selection(document)
    const { body } = document
    let { innerHTML } = body

    if (innerHTML === '<br>' || innerHTML === '') {
      for (const [element, highlight] of tasks.get(document)) {
        const { nodeName } = element

        element.classList.remove(modifier)

        if (nodeName === 'SELECT') {
          highlight(element, modifier, null, body)
        }
      }
    } else {
      for (const [element, highlight] of tasks.get(document)) {
        element.classList.remove(modifier)

        for (const text of texts) {
          highlight(element, modifier, text, body)
        }
      }
    }
  }
})

export const getChild = ({ children }) => {
  const [tag] = children
  const { tagName } = tag

  if (tagName === 'BR') {
    return tag
  }

  return getChild(tag)
}

const onInput = object(onCaretMove, {
  type: input
})

const onSelectionChange = object(onCaretMove, {
  type: selectionChange
})

export const onLoad = object(listener, {
  type: load,
  passive,
  once,
  task: async (
    iframe
  ) => {
    const { contentWindow, ownerDocument } = iframe
    const { document } = contentWindow

    tasks.set(document, params.get(iframe))
    onInput.listen(document)
    onSelectionChange.listen(document)

    if (ownerDocument.contains(iframe)) {
      await removed(iframe)
    }

    params.delete(iframe)
    tasks.delete(document)
  }
})

export const insert = (
  rte,
  text
) => {
  globals.ea_rte_exec_insert(rte, text)
}
export const command = (
  rte,
  command,
  options
) => {
  globals.ea_rte_command(rte, command, options)
}

export const command_clear = (
  rte,
) => {
  globals.ea_rte_command_clear(rte)
}

export default (
  button,
  { highlight }
) => {
  const { form, ownerDocument } = button
  const rte = form ? one('iframe[data-rte]', form) : one('iframe[data-rte]', ownerDocument)
  const { contentWindow } = rte

  if (!params.has(rte)) {
    params.set(rte, new Map())
  }

  params.get(rte).set(button, highlight)

  if (contentWindow) {
    return onLoad.task(rte)
  }

  onLoad.listen(rte)
}
